setLiveAccessEventDetailsError